export default {
  name: "scopedSlots",
  components: {},
  props: {
    fieldName: String,
    value: [Number, String, Object, Array]
  },
  model: {
    prop: "value",
    event: "update"
  },
  data() {
    return {
      realValue: ""
    };
  },
  watch: {
    realValue(e) {
      if (this.realValue != this.value) {
        this.$emit("update", e);
      }
    },
    value(e) {
      if (this.realValue != this.value) {
        this.realValue = e;
      }
    }
  },
  created() {
    this.realValue = this.value;
  },
  methods: {
    /**
     * @description: 获取值
     * @param {*}
     * @return {*}
     */
    getValue() {
      return this.realValue;
    },
    /**
     * @description: 赋值
     * @param {*}
     * @return {*}
     */
    setValue(e) {
      this.updateValue(e);
    },
    /**
     * @description: 更新数据
     * @param {*} e
     * @return {*}
     */
    updateValue(e) {
      this.realValue = e;
    }
  },
  render(h) {
    const { realValue, $scopedSlots, updateValue, fieldName } = this;
    return h(
      "div",
      {
        class: "data-form-scopedSlots"
      },
      [$scopedSlots.default(realValue, updateValue, fieldName)]
    );
  }
};
